import PropTypes from "prop-types";
import { scroller } from "react-scroll";
import Overlay from "react-overlays/Modal";
import cn from "classnames";
import Div100vh from "react-div-100vh";
import IconClose from "solar/icons/IconClose";
import ModalContainer from "components/shared/stays/ModalContainer";
import Button from "solar/components/Button";
import styles from "components/shared/stays/ModalFull.module.scss";

export default function ModalFull({
  scroll = false,
  anchor = null,
  show,
  handleClose,
  pagination = null,
  children,
  light = true,
}) {
  function scrollToAnchor() {
    scroller.scrollTo(anchor, {
      duration: 1000,
      delay: 250,
      smooth: "easeOutQuint",
      offset: 83, // rt: this should be dynamic
      containerId: "modalScrollContainer",
    });
  }

  return (
    <Overlay
      show={show}
      onShow={anchor && scrollToAnchor}
      onEscapeKeyDown={handleClose}
      className={styles.dialog}
      restoreFocusOptions={{ preventScroll: true }}
    >
      <Div100vh>
        <div className={cn(styles.content, light ? styles.light : styles.dark)}>
          <div className={styles.navigation}>
            <ModalContainer>
              <div className={styles.structure}>
                <div>
                  <Button
                    size={1}
                    ghost
                    onClick={handleClose}
                    className={styles.close}
                    icon={<IconClose />}
                  >
                    Close
                  </Button>
                </div>
                {pagination && (
                  <div className={styles.pagination}>{pagination}</div>
                )}
              </div>
            </ModalContainer>
          </div>
          <div
            className={cn(scroll && styles.scroll)}
            id="modalScrollContainer"
          >
            {children}
          </div>
        </div>
      </Div100vh>
    </Overlay>
  );
}

ModalFull.propTypes = {
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  pagination: PropTypes.node,
  scroll: PropTypes.bool,
  anchor: PropTypes.string,
  light: PropTypes.bool,
};
